import { createContext } from 'react';

export const PageDataContext = createContext([{}, () => {}]);

export const StateListContext = createContext([{}, () => {}]);

export const AirportListContext = createContext([{}, () => {}]);

export const AirlinesContext = createContext([{}, () => {}]);

export const FilterContext = createContext([{}, () => {}]);

export const TabContext = createContext([{}, () => {}]);

export const SheetContext = createContext([{},  () => {}])

export const CountryListContext = createContext([{}, () => {}]);
